export const DEFAULT_REALM = 'srh';
